import { DateTimeFilterChip, HoldCreatedAtFilterChip, YAW__JourneyCreatedAtFilterChip } from './date_time.js';
import { IntegerFilterChip, RatingFilterChip } from './number.js';
import { RadioButtonFilterChip, CheckBoxFilterChip, YAW__AssignmentStatusFilterChip } from './selection.js';
import { TextFieldFilterChip } from './text_field.js';
import { YAW__AssignmentDurationThresholdFilterChip } from './option.js';
import { YAW__VertexNameFilterChip, YAW__JourneyStatusFilterChip } from './combiner.js';

const FilterChips = {
  DateTimeFilterChip,
  HoldCreatedAtFilterChip,
  YAW__JourneyCreatedAtFilterChip,
  IntegerFilterChip,
  RatingFilterChip,
  RadioButtonFilterChip,
  CheckBoxFilterChip,
  TextFieldFilterChip,
  YAW__AssignmentStatusFilterChip,
  YAW__AssignmentDurationThresholdFilterChip,
  YAW__VertexNameFilterChip,
  YAW__JourneyStatusFilterChip
};

const FilterChip = {
  props: {
    filter: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: true
    }
  },

  render: function(h) {
    return h(this._getComponent(), {
      props: {
        filter: this.filter,
        removable: this.removable
      },
      on: {
        remove: this.removeHandler
      }
    });
  },

  methods: {
    removeHandler: function(filter) {
      this.$emit('remove', filter);
    },

    _getComponent: function() {
      var type;

      type = this.filter.field.type.demodulize();
      return FilterChips[`${type}FilterChip`] || FilterChips[`YAW__${type}FilterChip`] || TextFieldFilterChip;
    }
  }
};

export default FilterChip;
